import moment, { MomentInput } from 'moment-timezone';
import { useDispatch } from 'react-redux';
import { downloadAsCsvFile } from 'utils/csv';
import { displayDate, ES_DATE_FORMAT } from 'utils/date';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { CSV_COPY, CUSTOM_EVENTS_CSV_TABLE_LABELS } from '../constants';
import { MergedCustomEvent } from '../types';

export const formatCsvEvent = (event: MergedCustomEvent) => {
  const csvEventFields = Object.keys(CUSTOM_EVENTS_CSV_TABLE_LABELS);
  return csvEventFields.map((field) => {
    const val = event[field as keyof MergedCustomEvent];
    if (field === 'workflowTriggers') {
      return event?.workflowTriggers?.length ?? 0;
    }
    if (field === 'lastSeen') {
      return !val ? 'Never' : displayDate(moment(val as MomentInput), ES_DATE_FORMAT);
    }
    if (field === 'retentionPolicy' && typeof val === 'number' && val < 1) return 'Unlimited';
    if (typeof val === 'boolean') return String(val);
    return Array.isArray(val) ? val.length : val;
  });
};

export const useExportCustomEvents = (filteredCustomEvents: MergedCustomEvent[]) => {
  // Format data for CSV export
  const headerRow = Object.values(CUSTOM_EVENTS_CSV_TABLE_LABELS);
  const dispatch = useDispatch();

  const tableRows = filteredCustomEvents.map((e) => formatCsvEvent(e));
  return () => {
    try {
      downloadAsCsvFile({ rows: [headerRow, ...tableRows], fileName: CSV_COPY.fileName });
      dispatch(addPositiveToast(CSV_COPY.successMessage));
    } catch (error) {
      dispatch(addNegativeToast(CSV_COPY.failureMessage));
    }
  };
};
